import * as Yup from "yup";

export const LoginSchema = Yup.object({
    phone: Yup.string().required("Enter Username"),
    password: Yup.string().required("Enter Your Password"),
});